import { UscStoreService } from "../../services/usc-store/usc-store.service";
import { DataTableAdapter } from "../../adapters/datatable.adapter";
import { ViewColumnField } from '../../models/view-config/view-column-field.model';
import { UscDialogComponent } from "../usc-store/usc-dialog/usc-dialog.component";
import { UscTimeslotPickerComponent } from "../usc-store/usc-timeslot-picker/usc-timeslot-picker.component";
import { ViewButton } from "../../models/view-config/view-button.model";
import { ViewImageButton } from "../../models/view-config/view-image-button.model";
import { UscModalComponent } from "../usc-store/usc-modal/usc-modal.component";
import { DialogComponent } from "../common/dialog/dialog.component";
import { AdminService, ApiService } from "../../services";
import { Observable } from "rxjs";
import { FcmActionType, RECORD_MEETING, User } from "../../models";
import { NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { UscUserLookupComponent } from "../usc-store/usc-user-lookup/usc-user-lookup.component";

export class UscStoreVisitDataTableAdapter extends DataTableAdapter {

    uscStoreService: UscStoreService;
    apiService: ApiService;
    store_team_ID: string;
    target_item: any;
    public last_fcm_reload_time: string;
    public current_store: any;

    constructor(view: string, serviceCollection: any, store_team_ID: string) {
        super(view, serviceCollection);
        this.store_team_ID = store_team_ID;
        if (serviceCollection['uscStoreService']) this.uscStoreService = serviceCollection['uscStoreService'];
    }

    public initialize(): void {
        super.initialize();

        var currentUser = this.authService.getAuth();
        var current_view = this.uscStoreService.getCurrentView();
        // map to view_store_visit_scheduled_appt since it is the default view of the "Store Visits" tab, 
        if (current_view == this.uscStoreService.view_usc_store_visits) current_view = this.uscStoreService.view_store_visit_waiting_appt;

        // monitor current store change
        if (this.uscStoreService.isLeader()) this.current_store = this.uscStoreService.getSvtStoreUserByScope();
        this.uscStoreService.svtCurrentStore.subscribe(store => {
            this.current_store = store;
            if (store != null) this.reloadItems();
        })

        // monitor store visit view fcm reload command
        this.messagingService.currentFcmMessage.subscribe(message => {
            if (this.uscStoreService.isFcmPushCommandEnabled() && message && !this.is_disposed) {
                if (currentUser && message && message.data && message.data.actions) {
                    var actions = JSON.parse(message.data.actions);
                    // find meeting action
                    var action = actions.find(a => a.action_type == FcmActionType.ServerAction && a.record_type == RECORD_MEETING && a.actionID == "pull");
                    if (action && action.detail.time != this.last_fcm_reload_time) {
                        var action_views = action && action.detail ? action.detail.views : "";
                        if (action_views) {
                            // reload matched view if fcm sender is not current user
                            var isSameCurrentView = action_views.indexOf(current_view) >= 0;
                            var isNotFcmInitiator = action.detail.modified_by_user_ID != currentUser.ID;
                            var isSameCurrentStore = this.current_store == null || this.current_store.store_ID == action.detail.store_ID || this.current_store.store_team_ID == action.detail.team_ID;
                            if (isSameCurrentView && isNotFcmInitiator && isSameCurrentStore && current_view != this.uscStoreService.view_store_scheduling_setup) {
                                this.last_fcm_reload_time = action.detail.time;
                                this.reloadItems();
                            }
                        }
                    }
                }
            }
        });
    }

    public getDetailItems(init_filter_fields: boolean): any {
        var user = this.authService.getActive();
        if (this.uscStoreService.isLeader()) {
            var current_store = this.uscStoreService.getCurrentStoreVisitStore();
            if (current_store) {
                this.getStoreVisitItemsByView(init_filter_fields, '0', current_store.store_ID);
            } else {
                this.is_loading_data = false;
            }
        } else {
            this.getStoreVisitItemsByView(init_filter_fields, this.store_team_ID);
        }
    }

    public getStoreVisitItemsByView(init_filter_fields: boolean, store_team_ID, sid: string = null): void {
        var dlg = this.dialogService.showLoadingDlg(DialogComponent, { msg: "Loading..." });
        this.uscStoreService.getStoreVisitItemsByView(this.datatable_view, store_team_ID, sid).subscribe(data => {
            this.data_items = data;
            this.processDataItems(this.data_items, init_filter_fields);
            this.is_loading_data = false;
            dlg.dismiss();
        })
    }

    getFieldValueStyle(data_item: any, field: ViewColumnField) {
        var fvc = {};
        //if (data_item.visitor_type == "Business") fvc["background-color"] = "pink";                   // default business bg-color
        if (this.datatable_view == this.uscStoreService.view_store_visit_waiting_appt) {
            if (data_item.visitor_in_store != "Yes") fvc["background-color"] = "pink";                  // customer not in store
            else if (data_item.last_call_customer_time) {                                               // customer called
                var min_date = new Date(1901, 1, 1);
                var last_call_customer_time = new Date(Date.parse(data_item.last_call_customer_time));
                if (last_call_customer_time > min_date) fvc["background-color"] = "#d3ffd3";
            } else if (data_item.me_sub_type == 'Online Appointments' || data_item.me_sub_type == 'Associate Appointments') {
                fvc["background-color"] = "#ffffbf";
            }

        } else if (this.datatable_view == this.uscStoreService.view_store_visit_scheduled_appt) {
            var now = new Date();
            var appt_time = new Date(Date.parse(data_item.appointment_time));
            if (appt_time < now) fvc = { "background-color": "pink" };                                 // late for appt
        } else if (this.datatable_view == this.uscStoreService.view_store_visit_service_completed) {
            if (data_item.dl_sub_type == 'Purchase') fvc["background-color"] = "#d3ffd3";               // purchase
            if (data_item.dl_sub_type == 'No Purchase') fvc["background-color"] = "pink";               // no-purchase
        }
        return fvc;
    }

    public getFieldValue(data_item: any, field: ViewColumnField): any {
        if (data_item && field) {
            var field_value = data_item[field.key];
            if (field.sn_calc_formula) {
                var sn_calc_formula = this.translatorService.translate(null, data_item, field.sn_calc_formula);
                if (sn_calc_formula) {
                    var formula_results = data_item.formula_results;
                    if (field.sn_calc_formula_frequency > 0) {
                        formula_results = this.formulaService.calculateFormulaValuesByItem(this.table_view_config.view_formulas, data_item);
                    }
                    var fr = formula_results.find(f => f.name == sn_calc_formula);
                    field_value = fr.result;
                }
            }

            var isNotScheduledAppt = data_item.me_sub_type == 'Bill Payment' || data_item.me_sub_type == 'Sales Associate';
            switch (field.key) {
                case 'cfd_qrfv':
                    field_value = field_value != null ? field_value : '';
                    if (data_item.me_sub_type == 'Bill Payment') field_value = 'N/A';
                    break;
                case 'appointment_time':
                    field_value = field_value ? this.calendarService.getDateText(new Date(Date.parse(field_value)), 'hh:mm tt') : 'N/A';
                    break;
                case 'check_in_time': field_value = this.calendarService.getDateText(new Date(Date.parse(field_value)), 'hh:mm tt'); break;
                case 'service_start_time': field_value = this.calendarService.getDateText(new Date(Date.parse(field_value)), 'hh:mm tt'); break;
                case 'waiting_time':
                case 'serving_time':
                    var total_minutes = parseInt(field_value);
                    if (total_minutes == 0) total_minutes = 1;
                    var hours = Math.floor(total_minutes / 60);
                    var minutes: any = total_minutes % 60;
                    minutes = minutes < 10 ? '0' + minutes.toString() : minutes.toString();
                    field_value = `${hours}:${minutes}`;
                    break;
                case 'co_work_phone1':
                    field_value = this.formatContactNumber(field_value);
                    break;
                case 'spanish_requested':
                    field_value = field_value == 'Yes' ? field_value : '';
                    break;
            }

            return field_value != null ? field_value : 0;
        }
        return null;
    }

    formatContactNumber(phone:string) {
        var formatted = "";
        if (phone && phone.length == 10) {
          formatted = phone.substring(0, 3) + '-' + phone.substring(3, 6) + '-' + phone.substring(6, 10);
        }
        return formatted;
    }

    public processEndServiceAction(img_btn: ViewImageButton, item: any, field: ViewColumnField) {
        var loading_message = img_btn.action_loading_message ? img_btn.action_loading_message : "Updating Appointment...";
        var dlg = this.dialogService.showLoadingDlg(DialogComponent, { msg: loading_message });
        this.uscStoreService.processActionOnViewItem(this.datatable_view, item.view_ID, img_btn.action, null).subscribe(
            result => {
                dlg.dismiss();
                const modalRef = this.ngbModal.open(UscDialogComponent, { backdrop: 'static', keyboard: false });
                modalRef.componentInstance.parentView = this.datatable_view;
                modalRef.componentInstance.data = item;
                modalRef.componentInstance.dlgType = this.uscStoreService.dialog_type_svt_end_service_outcome;
                modalRef.result.then((result) => {
                    var outcome_view = '';
                    if (result.response == this.uscStoreService.response_svt_end_service_purchase) outcome_view = this.uscStoreService.form_purchase;
                    if (result.response == this.uscStoreService.response_svt_end_service_no_purchase) outcome_view = this.uscStoreService.form_no_purchase;
                    this.showOutcomeForm(item, outcome_view, img_btn.action, img_btn.reload_post_action);
                });
            }, error => {
                this.sessionService.log('sn_view_action::' + img_btn.action + ' failed');
                dlg.dismiss();
            }
        )
    }

    public showOutcomeForm(view_item: any, outcome_view: string, action: string, reload_post_action: boolean) {
        const modalRef = this.ngbModal.open(UscModalComponent, { backdrop: 'static', keyboard: false });
        modalRef.componentInstance.view = outcome_view;
        modalRef.componentInstance.data = view_item;
        modalRef.componentInstance.openCustomInputEvent = this.openCustomInputDialog;
        if (action == this.uscStoreService.form_reschedule) modalRef.componentInstance.onSubmitOverrideEvent = this.onReschedule;
        modalRef.result.then((result) => {
            if (outcome_view == this.uscStoreService.form_purchase || outcome_view == this.uscStoreService.form_no_purchase) {
                this.showOutcomeForm(view_item, this.uscStoreService.form_future_sale, null, reload_post_action);
            } else {
                if (reload_post_action) this.reloadItems();
            }
        }, (error) => {
            if (reload_post_action) this.reloadItems();
            console.log(error);
        });
    }

    protected processActionOnViewItem(btn: ViewButton, item: any, field: ViewColumnField) {
        var img_btn = btn as ViewImageButton;
        var loading_message = img_btn.action_loading_message ? img_btn.action_loading_message : "Updating Appointment...";
        var dlg = this.dialogService.showLoadingDlg(DialogComponent, { msg: loading_message });
        var params = { scheduling_queue_datetime_modified: item.scheduling_queue_datetime_modified };
        this.uscStoreService.processActionOnViewItem(this.datatable_view, item.view_ID, img_btn.action, params).subscribe(
            result => {
                dlg.dismiss();
                if (result && result.errors) {
                    var modalRef = this.dialogService.showDialog(DialogComponent, this.dialogService.dlg_type_confirmation, { msgList: ["Unable to process request.  Please contact SalesNOW support."] });
                    modalRef.result.then((result) => { dlg.dismiss(); }, (reason) => { })
                } else {
                    if (img_btn.action == 'action_usc_svt_start_serving') this.uscStoreService.setCurrentView(this.uscStoreService.view_store_visit_serving_now);
                    else if (img_btn.action == 'action_usc_svt_end_service') this.uscStoreService.setGotoItem(item);
                    else if (btn.reload_post_action) this.reloadItems();
                }
            }, error => {
                this.sessionService.log('sn_view_action::' + img_btn.action + ' failed');
                dlg.dismiss();
            }
        )
    }

    openUserLookup(btn: ViewButton, item: any, field: ViewColumnField) {
        const modalRef = this.ngbModal.open(UscUserLookupComponent, { size: "lg", backdrop: 'static', keyboard: false });
        modalRef.componentInstance.lookup_scope = this.adminService.list_user_scope_user_team;
        modalRef.result.then((result) => {
            console.log(result);
            var dlg = this.dialogService.showLoadingDlg(DialogComponent, { msg: 'Reassigning Appointment...' });
            var params = { idList: item.view_ID, user_ID: result.selectedItem.ID, asr: 1 };
            this.uscStoreService.processActionOnViewItems(this.datatable_view, this.uscStoreService.action_mass_reassign, params).subscribe(
                result => {
                    dlg.dismiss();
                    if (result && result.errors) {
                        var modalRef = this.dialogService.showDialog(DialogComponent, this.dialogService.dlg_type_confirmation, { msgList: ["This user is currently serving another customer and is unavailable at this time."] });
                        modalRef.result.then((result) => { dlg.dismiss(); }, (reason) => { })
                    } else if (btn.reload_post_action) this.reloadItems();
                }
            );
        }, (reason) => {
            console.log("User Lookup Closed");
        });
    }

    public onBtnClick(btn: ViewButton, item: any, field: ViewColumnField) {
        console.log("onBtnClick::" + btn.event);
        var img_btn = btn as ViewImageButton;
        switch (btn.event) {
            case "sn_view_action": {
                if (img_btn.action == 'action_usc_svt_end_service') {
                    this.processEndServiceAction(img_btn, item, field);
                } else if (img_btn.action == 'action_usc_svt_reassign') {
                    this.openUserLookup(img_btn, item, field);
                } else if (img_btn.action == 'action_usc_svt_call_customer' || img_btn.action == 'action_usc_svt_start_serving') {
                    var message = `Do you want to call ${item.customer}?`;
                    if (img_btn.action == 'action_usc_svt_start_serving') message = `Do you want to start service with ${item.customer}?`;
                    var modalRef = this.dialogService.showYesNoDlg(DialogComponent, { msg: [message], confirm_label: 'Confirm', cancel_label: 'Cancel' });
                    modalRef.result.then(
                        (result) => { this.processActionOnViewItem(img_btn, item, field); },
                        (reason) => { }
                    );
                } else {
                    this.processActionOnViewItem(img_btn, item, field);
                }
            }
                break;
            case "sn_dialog_action": {
                const modalRef = this.ngbModal.open(UscDialogComponent, { backdrop: 'static', keyboard: false });
                modalRef.componentInstance.parentView = this.datatable_view;
                modalRef.componentInstance.data = item;
                modalRef.componentInstance.dlgType = img_btn.action;
                modalRef.result.then((result) => {
                    var params: any = {};
                    var action = "";
                    //var reload_post_action = btn.reload_post_action;
                    if (img_btn.action == this.uscStoreService.dialog_type_svt_adjust_queue_position) {
                        params = { position_offset: result.position_offset };
                        action = this.uscStoreService.action_svt_move_by_offset;
                    }

                    //var reloadItems = this.reloadItems;
                    var dlg = this.dialogService.showLoadingDlg(DialogComponent, { msg: 'Reloading...' });
                    this.uscStoreService.processActionOnViewItem(this.datatable_view, item.view_ID, action, params).subscribe(
                        result => {
                            dlg.dismiss();
                            if (result && result.errors) {
                                var modalRef = this.dialogService.showDialog(DialogComponent, this.dialogService.dlg_type_confirmation, { msgList: ["Unable to process request.  Please contact SalesNOW support."] });
                                modalRef.result.then((result) => { dlg.dismiss(); }, (reason) => { })
                            } else {
                                if (btn.reload_post_action) this.reloadItems();
                            }
                        }
                    );
                });
            }
                break;
            case "sn_form_action":
                this.showOutcomeForm(item, img_btn.action, img_btn.action, img_btn.reload_post_action);
                break;
        }
    }

    onReschedule(services, event, btn_event, newFormFields) {
        var dlg = this.dialogService.showLoadingDlg(DialogComponent, { msg: "Rescheduling Appointment..." });
        var params = { event: btn_event };
        this.uscStoreService.saveOutcome(services.view, services.view_ID, newFormFields, params).subscribe(
            result => {
                if (result && result.errors) {
                    dlg.dismiss();
                    var modalRef = this.dialogService.showDialog(DialogComponent, this.dialogService.dlg_type_confirmation, { msgList: ["Unable to process request.  Timeslot not available."] });
                    modalRef.result.then((result) => { dlg.dismiss(); }, (reason) => { })
                } else {
                    dlg.dismiss();
                    if (services.activeModal) services.activeModal.close({ event: btn_event, data: null });
                }
            }
        );
    }

    public openCustomInputDialog(formValues, field) {
        if (field.key == "cfd_fumts2" || field.key == "cfd_fumts") {
            var modal = this.ngbModal.open(UscTimeslotPickerComponent, { size: "lg", backdrop: 'static', keyboard: false });
            modal.componentInstance.schedule_date = new Date(formValues.cfd_fumd);
            modal.componentInstance.view_ID = formValues.dl_ID;
            return modal;
        }
        return null;
    }

    public openOkDialog(message, bReloadItem) {
        const modalRef = this.ngbModal.open(UscDialogComponent, { backdrop: 'static', keyboard: false });
        modalRef.componentInstance.dlgType = this.uscStoreService.dialog_type_ok_prompt;
        modalRef.componentInstance.msg_config = { msg: message };
        modalRef.result.then((result) => {
            if (bReloadItem) this.reloadItems();
        }, (reason) => {
            if (bReloadItem) this.reloadItems();
        });
    }

    public isPagingEnabled(): boolean {
        return false;
    }

    public getNoDataMessage(): string {
        return "No Appointments Found";
    }
}


// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-store-scheduling/usc-store-visit-dt-adapter.ts